'use strict';
import Vue from 'vue';
import proto from '../../protocol';
import {
    ACT_HANDLE_HISTORY_CALL_CHANGE_EVENT,
    ACT_HANDLE_HISTORY_CALL_EVENT,
    ACT_NOTIFY_NEW_ADD,
    ACT_NOTIFY_NEW_REMOVE_BY_DATA,
    ACT_UPDATE_CALLS_AFTER_CONTACT_DELETED,
} from '../actionsTypes'
import {
    GET_CALLS_HISTORY_LIST,
    GET_CALLS_UNWATCHED_CALLS_COUNT,
    GET_CALLS_UNWATCHED_CALLS,
    GET_CALLS_WATCHED_CALLS_STATUS,
} from '../gettersTypes'
import { NOTIFY_DATA_TYPES } from './notificationsNew'
import { NOTIFICATIONS_NEW } from '../modulesNames'
import { i18n } from '../../../ext/i18n'

import moment from 'moment'

export default  {
    namespaced: true,
    state: {
        calls: {},
        unwatchedCalls: {},
        watchedCallsStatus: false,
    },
    getters: {
        [GET_CALLS_HISTORY_LIST](state) {
            return Object.values(state.calls).map(call => {
                return {
                    ...call,
                    ...{
                        date: formatTime(call.epochTime),
                        dateDetails: formatTimeDetails(call.epochTime)
                    }
                }
            }).sort(({epochTime: aEpochTime}, {epochTime: bEpochTime}) => bEpochTime - aEpochTime)
        },
        [GET_CALLS_UNWATCHED_CALLS_COUNT](state) {
            if(state.unwatchedCalls) return Object.keys(state.unwatchedCalls).length
        },
        [GET_CALLS_UNWATCHED_CALLS](state) {
            return Object.values(state.unwatchedCalls)
        },
        [GET_CALLS_WATCHED_CALLS_STATUS](state) {
            return state.watchedCallsStatus
        },
    },
    actions: {
        updateCalls: ({state, commit, dispatch, rootGetters}) => new Promise((resolve, reject) =>  {
            proto.getHistoryCalls({ count: 100 }, async (items) => {
                await items.map((call) => dispatch('updateCall', {call, notify: false}))
                /*if (Object.keys(state.unwatchedCalls).length) {
                    const [id, call] = Object.entries(state.unwatchedCalls).pop()
                    dispatch(`${NOTIFICATIONS_NEW}/${ACT_NOTIFY_NEW_ADD}`, { type: NOTIFY_DATA_TYPES.MISSED_CALL, payload: call }, {root: true})
                }*/
                resolve()
            })
        }),
        updateCall({commit, dispatch}, {call, notify = true}) {
            commit('addCall', call)
            if (call.type !== 'out' && !call.duration && !call.status) {
                commit('addUnwatchedCall', call)
                if (notify) dispatch(`${NOTIFICATIONS_NEW}/${ACT_NOTIFY_NEW_ADD}`, { type: NOTIFY_DATA_TYPES.MISSED_CALL, payload: call }, {root: true})
            }
        },
        updateStatus({getters, dispatch}, params) {
            proto.setHistoryCallStatus(params, data => {
                if (data && data.rev) dispatch(ACT_HANDLE_HISTORY_CALL_CHANGE_EVENT, params)
            })
        },
        [ACT_UPDATE_CALLS_AFTER_CONTACT_DELETED]({commit}, params) {
            commit('updateCallsAfterDeleted', params)
        },
        [ACT_HANDLE_HISTORY_CALL_EVENT]({commit, dispatch}, call) {
            dispatch('updateCall', {call})
        },
        [ACT_HANDLE_HISTORY_CALL_CHANGE_EVENT]({state, commit, dispatch, rootGetters}, params) {
            console.log('updateCallChangeEvent')
            const call = state.calls[params.id]
            if (call) {
                if (params.status === 'deleted') Vue.delete(state.calls, params.id)
                else Vue.set(call, 'status', params.status);
            }
            const unwatchedCall = state.unwatchedCalls[params.id]
            if (unwatchedCall) {
                Vue.delete(state.unwatchedCalls, params.id)
                dispatch(`${NOTIFICATIONS_NEW}/${ACT_NOTIFY_NEW_REMOVE_BY_DATA}`, {
                    type: NOTIFY_DATA_TYPES.MISSED_CALL,
                    payload: params
                }, {root: true})
            }
        },
    },
    mutations: {
        addCall: (state, call) => {
            extendCall(call)
            Vue.set(state.calls, call.id, call)
        },
        addUnwatchedCall(state, call) {
            Vue.set(state.unwatchedCalls, call.id, call)
        },
        updateCalls: function (state, calls) {
            Vue.set(state, 'calls', calls);
        },
        updateCallsAfterDeleted: (state, params) => {
            const { cid } = params
            for (let call of Object.values(state.calls)) {
                if(call.cid === cid) {
                    call.cid = undefined
                    call.fio = call.number
                }
            }
        },
    }
};

function extendCall(call) {
    call.epochTime = moment().subtract(call.time, 'seconds').unix()
}

let locale = i18n.messages[i18n.locale]
let localeFormatTime = locale['channel-comp']

function formatTime(timeCall) {
    let locale = localeFormatTime
    let result;
    let timeCallFormat = moment.unix(timeCall);
    let today = moment().startOf('day');
    let yesterday = moment().subtract(1, 'days').startOf('day');
    let twoDays = moment().subtract(2, 'days').startOf('day');
    if(timeCallFormat.isAfter(today)) {
        result = timeCallFormat.format('HH:mm');
    } else if(timeCallFormat.isBefore(today) && timeCallFormat.isAfter(yesterday)) {
        result = locale.yesterday;
    } else if(timeCallFormat.isBefore(yesterday) && timeCallFormat.isAfter(twoDays)) {
        result = locale['before-yest'];
    } else if (timeCallFormat.format('YYYY') === moment().format('YYYY')) {
        result = timeCallFormat.format('DD MMM');
    } else {
        result = timeCallFormat.format('DD MMM YYYY');
    }
    return result;
}
function formatTimeDetails(timeCall) {
    let result = {
        data: null,
        time: null
    };
    let timeCallFormat = moment.unix(timeCall);
    let today = moment().startOf('day');
    let yesterday = moment().subtract(1, 'days').startOf('day');
    let twoDays = moment().subtract(2, 'days').startOf('day');
    if(timeCallFormat.isAfter(today)) {
        result.data = locale.settings.today;
        result.time = timeCallFormat.format('HH:mm');
    } else if(timeCallFormat.isBefore(today) && timeCallFormat.isAfter(yesterday)) {
        result.data = locale['channel-comp'].yesterday;
        result.time = timeCallFormat.format('HH:mm');
    } else if(timeCallFormat.isBefore(yesterday) && timeCallFormat.isAfter(twoDays)) {
        result.data = locale['channel-comp']['before-yest'];
        result.time = timeCallFormat.format('HH:mm');
    } else {
        result.data = timeCallFormat.format('DD MMM YYYY');
        result.time = timeCallFormat.format('HH:mm');
    }
    return result;
}
